<template>
  <b-overlay id="overlay-background" class="overlay-config calendar-table" :show="loading" rounded="sm">
    <div class="height-grid-card">
      <b-table id="table-calendar" class="height-table" hover sticky-header small striped :items="calendars"
        :fields="fields" sort-by="nameCalendar">
        <template v-slot:cell(nameCalendar)="row">
          <div :id="'calendar-' + row.item.id" class="calendar-name" @click="() => { sendIdCalendar(row.item.id) }">
            <b-icon v-if="row.item.notVinculated == true" icon="exclamation-triangle-fill" class="calendarIcon"
              :title="$t('calendar-pattern')"></b-icon>
            <span>{{ row.item.nameCalendar }}</span>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <img src="@/assets/excluir.png" :alt="$t('excluir-calendario')" style="max-height: 25px"
            :title="$t('excluir-calendario')" @click="askDeleteCalendar(row.item.id)" />
        </template>
      </b-table>
    </div>
    <b-modal id="showDeleteCalendar" ok-variant="danger" :title="$t('atencao')" :ok-title="$t('yes')"
      :cancel-title="$t('no')" @ok="deleteCalendar()">
      <p>{{ $t('deseja-realmente-excluir-o-calendario') }}</p>
      <p>{{ $t('will-remove-historic') }}</p>
    </b-modal>


    <b-modal id="exportCalendarModal" size="xl" hide-footer>
      <template #modal-title>
        <b-icon icon="calendar2-week-fill" class="calendarIcon"></b-icon>
        {{ $t('export-calendar') }}
      </template>

      <section class="exportModalContainer">
        <CustomCheckList :data="this.calendars" text="Marque os calendários que deseja exportar:" view-style="list"
          data-key="nameCalendar" identifier="calendar" :blockInput="false" />
        <CustomCheckList :data="months" text="Marque os meses que deseja exportar:" view-style="block" data-key="name"
          identifier="month" :blockInput="false" />
      </section>
      <section class="modalBtn">
        <button @click="() => this.$bvModal.hide('exportCalendarModal')">{{ $t('cancel') }}</button>
        <button @click="getCalendarsToExport">{{ $t('export') }}</button>
      </section>
    </b-modal>

    <b-modal id="importCalendarModal" size="lg" hide-footer>
      <template #modal-title>
        <b-icon icon="calendar2-week-fill" class="calendarIcon"></b-icon>
        {{ $t('import-calendar') }}
      </template>

      <section class="importModalContainer">
        <p>Selecione o arquivo para a importação:</p>
        <b-form-file v-model="importedFile" :state="Boolean(importedFile)"
          placeholder="Selecione ou arraste o arquivo a ser importado." drop-placeholder="Arraste o arquivo aqui."
          accept=".xls,.xlsx" class="inputFile" browse-text="Buscar">
        </b-form-file>
        <span class="monthsFound" v-if="this.convertedFile != null && this.monthImported != null">{{ this.monthImported
          }}</span>
        <span class="monthsFound" v-if="this.convertedFile != null && this.monthImported == null">Arquivo
          Inválido</span>

        <CustomCheckList :data="months" text="Marque os meses que deseja exportar:" view-style="block" data-key="name"
          identifier="month" :blockInput="true" />
      </section>
      <section class="modalBtn">
        <button @click="() => this.$bvModal.hide('importCalendarModal')">{{ $t('cancel') }}</button>
        <button @click="importFileCalendar">{{ $t('import') }}</button>
      </section>
    </b-modal>

    <b-modal id="showHistoryCalendar" title="Histórico de Calendários Sazonais" hide-footer>
      <CalendarHistory :history="calendarsHistory" :restoreCalendarsFunc="restoreSelectedCalendars" />
    </b-modal>

    <b-modal id="calendarsDifference" :no-close-on-backdrop="true" :no-close-on-esc="true" ok-variant="danger"
      @ok="creatingNewImportedCalendars">
      <template #modal-title>
        <b-icon icon="exclamation-triangle-fill" class="calendarIcon"></b-icon>
        Aviso de Novos Calendários
      </template>
      <span>Você importou uma quantidade de Calendários Sazonais maior do que a existente atualmente. Deseja
        continuar?</span>
      <br />
      <br />
      <section v-if="importedCalendars.length > 0">
        <span>Os calendários a seguir serão atualizados.</span>
        <ul>
          <li v-for="(names, ni) in importedCalendars" :key="ni + 'imp'">{{ names }}</li>
        </ul>
      </section>
      <section v-if="newCalendars.length > 0">
        <span>Os calendários a seguir serão criados.</span>
        <ul>
          <li v-for="(nc, ci) in newCalendars" :key="ci + 'cr'">{{ nc.name }}</li>
        </ul>
      </section>
    </b-modal>

    <b-modal id="importCalendarConfirm" :no-close-on-backdrop="true" :no-close-on-esc="true" ok-variant="danger"
      @ok="saveImportedCalendars">
      <template #modal-title>
        <b-icon icon="calendar2-week-fill" class="calendarIcon"></b-icon>
        Detalhes da Importação
      </template>
      <span>Os calendários a seguir serão atualizados. Deseja continuar?</span>
      <ul>
        <li v-for="(names, ini) in importedCalendars" :key="ini + 'nini'">{{ names }}</li>
      </ul>
    </b-modal>

    <b-modal id="showBudgetCalendarModal" :no-close-on-backdrop="true" :no-close-on-esc="true" ok-variant="danger"
      @ok="saveBudgetCalendar">
      <template #modal-title>
        <b-icon icon="exclamation-triangle-fill" class="calendarIcon"></b-icon>
        Definir Calendário Budget
      </template>
      <span>Deseja mesmo salvar esse histórico como Budget (imutável)?</span>
    </b-modal>

    <b-modal id="accumulatedCalendarsModal" hide-footer>
      <template #modal-title>
        <b-icon icon="exclamation-triangle-fill" class="calendarIcon"></b-icon>
        Criar Calendário Acumulado
      </template>
      <b-form-input v-if="this.calendarsToAcc.length > 0" v-model="accumulatedCalendarName" placeholder="Digite o nome do calendário."></b-form-input>
      <CustomCheckList v-if="this.calendarsToAcc.length > 0" :data="this.calendarsToAcc"
        text="Marque os calendários que deseja acumular:" view-style="list" data-key="nameCalendar"
        identifier="calendar" :blockInput="false" />
        <p v-else>Não é possível acumular calendários. Nenhum calendário possui indicadores vinculados.</p>
      <section class="modalBtn" v-if="this.calendarsToAcc.length > 0">
        <button @click="() => this.$bvModal.hide('accumulatedCalendarsModal')">{{ $t('cancel') }}</button>
        <button @click="generateAccumulatedCalendar">{{ $t('criar') }}</button>
      </section>
    </b-modal>

    <b-modal id="addingNewCalendar" size="lg" :no-close-on-backdrop="true" :no-close-on-esc="true" hide-footer>
      <template #modal-title>
        <b-icon icon="calendar2-week-fill" class="calendarIcon"></b-icon>
        Deseja Vincular Indicadores?
      </template>
      <p>Vincule os indicadores aos calendários criados.</p>
      <span>Arraste os indicadores disponíveis aos novos calendários.</span>
      <section class="relatedImportContainer">
        <section class="relatedImportCalendars">
          <section v-for="(newCalendars, calendarsIDX) in newCalendars" :key="'vinculating-' + calendarsIDX">
            <span>{{ newCalendars.name }}</span>
            <input type="text" readonly v-model="newCalendars.indicatorName" placeholder="Arraste os indicadores"
              @drop="dropIndicatorToCalendar($event, newCalendars)" @dragover.prevent @dragenter.prevent
              @dragleave.prevent />
          </section>
        </section>
        <section class="relatedImportIndicators"
          v-if="SeasonalCalendarRepository && SeasonalCalendarRepository.indicatorsRelated.length > 0">
          <div v-for="(indicator, indicatorIDX) in SeasonalCalendarRepository.indicatorsRelated"
            :key="indicatorIDX + 'indicatorRelated'" draggable="true"
            @dragstart="moveIndicatorToVinculate($event, indicator)">
            <b-icon-arrows-move />
            <span>{{ indicator.indicatorName }}</span>
          </div>
        </section>
      </section>
      <section class="modalBtn">
        <button @click="saveImportedCalendars">{{ $t('vinculate-after') }}</button>
        <button @click="finishWithVinculatedIndicators">{{ $t('finalizar') }}</button>
      </section>
    </b-modal>
  </b-overlay>
</template>

<script>
import axios from 'axios'
// import moment from 'moment';
import { defaultSuccess, showError, urlMainAPI } from '../../../global'
import CustomCheckList from './CheckList.vue';
import CalendarHistory from './CalendarHistory.vue';
import SeasonalCalendarRepository from '../service/SeasonalCalendarRepository';
import * as XLSX from 'xlsx'
import { mapState } from "vuex";

export default {
  name: "TableCalendar",
  props: ["saveData", "refreshTableCalendar", "selectNameCalendar", "backLastCalendar",
    "exportCalendars", "importCalendars", "showHistory", "setBudgetCalendar", "openAccumulatedCalendar"],
  components: { CustomCheckList, CalendarHistory },
  computed: {
    ...mapState(["user"]),

    SeasonalCalendarRepository() {
      return SeasonalCalendarRepository;
    },
  },
  data: function () {
    return {
      calendars: [],
      selectedCalendar: null,
      fields: [
        { key: "nameCalendar", label: this.$t('calendario') },
        { key: "revision", label: this.$t('revisao') },
        { key: "actions", label: this.$t('excluir') }
      ],
      loading: false,
      idSelected: false,
      lastId: 0,
      nameWasChanged: false,
      months: SeasonalCalendarRepository.MonthDict,
      monthBkp: SeasonalCalendarRepository.MonthDict,
      importedFile: null,
      convertedFile: null,
      monthImported: null,
      currentMonth: new Date().getMonth(),
      calendarsHistory: [],
      dateLocaleFormat: null,
      accumulatedCalendarName: null,
      importedCalendars: [],
      newCalendars: [],
      vinculatedIndicatorsToSave: [],
      maxCalendarId:0,
      monthsToCheck:[],
      calendarsToAcc:[],
    }
  },

  watch: {
    loading(val){
      SeasonalCalendarRepository.fullLoading = val
    },

    saveData() {
      this.refresh();
    },

    refreshTableCalendar() {
      this.nameWasChanged = true;
      this.refresh();
    },

    localRefresh(){
      this.refresh();
    },

    selectNameCalendar(name) {
      this.selectedCalendar = name
      this.nameWasChanged = true;
      this.refresh();
      this.waitLoading();
    },

    backLastCalendar() {
      this.sendIdCalendar(this.lastId)
    },

    exportCalendars() {
      this.$bvModal.show("exportCalendarModal");
    },

    importCalendars() {
      this.monthImported = "";
      this.importedFile = null;
      this.convertedFile = null;
      this.$bvModal.show("importCalendarModal");
    },

    showHistory() {
      this.$bvModal.show("showHistoryCalendar");
    },

    setBudgetCalendar() {
      this.$bvModal.show("showBudgetCalendarModal");
    },

    openAccumulatedCalendar() {
      this.calendarsToAcc = this.calendars.filter(item => !item.notVinculated)
      this.accumulatedCalendarName = "";
      this.$bvModal.show("accumulatedCalendarsModal");
    },

    importedFile(data) {
      if(data == null) return;
      this.readXslx(data)
    },

    convertedFile(data) {
      this.monthImported = null;
      if(data == null) return;
      if (data != null && data.length > 0) {
        let sheetNames = [];

        this.months.forEach(item => {
          let foundOnMonths = data.findIndex(dt => item.name.toLocaleLowerCase().trim() == dt.sheetName.toLowerCase().trim())

          if (foundOnMonths != -1 && foundOnMonths != undefined && foundOnMonths != null) {
            sheetNames.push(item.name);

            if (item.id >= this.currentMonth) item.disable = false;
          } else {
            item.disable = true;
          }

          item.checked = false;
        });

        if (sheetNames.length > 0) this.monthImported = `Meses encontrados: ${sheetNames.join(", ")}.`;
        else this.monthImported = null;
      }
    }
  },

  methods: {
    waitLoading() {
      setTimeout(() => {
        if (this.loading) {
          this.waitLoading();
        } else {
          let founded = this.calendars.find(c => c.nameCalendar == this.selectedCalendar)
          let id = founded ? founded.id : this.calendar[0].id
          this.sendIdCalendar(id)
        }
      }, 300)
    },

    async refresh() {
      this.loading = true
      await this.loadCalendars()
      this.loading = false
    },

    async loadCalendars(firstLoad) {
      this.loading = true;
      SeasonalCalendarRepository.fullLoading = true;
      const url = `${urlMainAPI}/getseasonalcalendar`
      await axios.get(url).then(res => {
        if (res.status != 200) return
        this.calendars = res.data.map(d => ({
          ...d, checked: false, disable: false, notVinculated: false
        }));
        SeasonalCalendarRepository.allCalendars = [...this.calendars]
        this.maxCalendarId = this.calendars.length > 0 ? Math.max(...this.calendars.map(o => o.id)) : 0;

        this.sendUpdateCalendar(firstLoad, res.data)
      }).catch(console.error)

      await axios.get(`${urlMainAPI}/getseasonalcalendarshistory`).then(res => this.calendarsHistory = res.data).catch(err => console.error(err))
      setTimeout(() => {
        if (SeasonalCalendarRepository.indicatorsRelatedIDS.length > 0) {
          this.calendars.forEach(item => {
            if (!SeasonalCalendarRepository.indicatorsRelatedIDS.includes(item.id)) item.notVinculated = true;
            else item.notVinculated = false;
          });
        }
      }, 200);

      this.loading = false;
      SeasonalCalendarRepository.fullLoading = false;
    },

    sendUpdateCalendar(firstLoad, calendars) {
      if (firstLoad && calendars.length != 0) {
        this.idSelected = calendars[0].id;
        setTimeout(() => this.sendIdCalendar(calendars[0].id), 150)
      }
      else if (!this.nameWasChanged)
        this.sendIdCalendar(0)
    },

    sendIdCalendar(id) {
      this.selectCalendar(id);
      this.lastId = this.idSelected;
      this.idSelected = id;
      this.$emit('setCalendar', id)
    },

    selectCalendar(id) {
      let el = document.getElementById("calendar-" + id)
      if (el) {
        document.querySelectorAll(".height-table > table > tbody > tr").forEach(e => e.classList.remove("calendar-selected"))
        el.parentNode.parentNode.classList.add("calendar-selected")
      }
    },

    askDeleteCalendar(idCalendar) {
      this.transientid = idCalendar;
      this.$bvModal.show('showDeleteCalendar')
    },

    moveIndicatorToVinculate(evt, ind) {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('calendarDragged', JSON.stringify(ind));
    },

    dropIndicatorToCalendar(evt, calendar) {
      let refMoved = evt.dataTransfer.getData('calendarDragged');
      let refToAdd = JSON.parse(refMoved);
      
      let alreadyAdded = this.newCalendars.filter(item => refToAdd.indicatorName == item.indicatorName);

      if(alreadyAdded.length > 0){
        this.$bvToast.toast("Esse indicador já está vinculado em outro calendário.", {
          title: "Indicador já Vinculado.",
          variant: "warning",
          toaster: 'b-toaster-bottom-left',
          solid: true
        })
        return;
      }

      calendar.indicatorName = refToAdd.indicatorName;
      calendar.indicatorId = refToAdd.indicatorId;
    },

    creatingNewImportedCalendars() {
      this.$bvModal.hide('calendarsDifference');
      this.$bvModal.show('addingNewCalendar');
    },

    finishWithVinculatedIndicators() {
      let vinculated = this.newCalendars.filter(item => item.indicatorId != null)
      if (vinculated.length > 0) {
        this.vinculatedIndicatorsToSave = vinculated.map(item => {
          this.maxCalendarId+=1
          return {
            indicatorId: item.indicatorId,
            productionUnitId: this.user.UnitId,
            system: this.user.onlineType[0],
            calendarId: item.calendarId
          }
        })
      }

      this.saveImportedCalendars();
    },

    async deleteCalendar() {
      const url = `${urlMainAPI}/deleteseasonalcalendar/${this.transientid}`
      await axios.get(url).then(async res => {
        this.loading = true;
        defaultSuccess(res.data)
        await this.loadCalendars(true)
      })
      this.loading = false;
    },

    async importFileCalendar() {
      if (this.importedFile == null) {
        this.$bvToast.toast("Selecione um arquivo .XLS ou .XLSX antes de importar.", {
          title: "Arquivo não selecionado.",
          variant: "warning",
          toaster: 'b-toaster-bottom-left',
          solid: true
        })
        return;
      }

      if (this.convertedFile == null) {
        this.readXslx(this.importedFile)
      }

      if (this.monthImported == null) {
        this.$bvToast.toast("O arquivo importado não está no formato padrão.", {
          title: "Arquivo Inválido.",
          variant: "warning",
          toaster: 'b-toaster-bottom-left',
          solid: true
        })
        return;
      }

      let checkedMonths = this.months.filter(item => item.checked == true);
      if (checkedMonths.length <= 0) {
        this.$bvToast.toast("Selecione os meses que deseja importar.", {
          title: "Nenhum mês selecionado.",
          variant: "warning",
          toaster: 'b-toaster-bottom-left',
          solid: true
        })
        return;
      }

      let calendarNames = [];
      let newCalendars = [];
      let monthsSelected = this.months.filter(item => item.checked == true && item.disable == false).map(i => i.name)

      this.convertedFile.forEach(cl => {
        cl.data.forEach(dt => {
          let namesFound = Object.keys(dt).filter(k => !["dia", "dia da semana"].includes(k.toLocaleLowerCase().trim()))

          if (namesFound.length > 0) {
            namesFound.forEach(f => {
              let findOnDatabase = this.calendars.filter(fdb => fdb.nameCalendar == f);

              if (findOnDatabase.length == 0 && !newCalendars.includes(f) && monthsSelected.includes(cl.sheetName)) newCalendars.push(f)

              if (!calendarNames.includes(f) && !newCalendars.includes(f) && monthsSelected.includes(cl.sheetName)) calendarNames.push(f)

            })
          }
        })
      })

      if (calendarNames.length > 0) this.importedCalendars = calendarNames;
      if (newCalendars.length > 0) {
        this.newCalendars = newCalendars.map(item => { 
          this.maxCalendarId+=1;
          return { name: item, calendarId: this.maxCalendarId, indicatorId: null, indicatorName: "" } 
        })
      }

      if (this.importedCalendars.length > 0 && this.newCalendars.length == 0) {
        this.$bvModal.show("importCalendarConfirm");
        return;
      }

      else if (this.newCalendars.length > 0) {
        this.$bvModal.show("calendarsDifference");
        return;
      }
    },

    readXslx(file) {
      if (file instanceof Blob) {

        const convertedXLSX = [];
        const reader = new FileReader();

        reader.onload = (evt) => {
          let currentMonth = new Date().getMonth();
          const data = new Uint8Array(evt.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          for (let name of workbook.SheetNames) {
            let isValid = SeasonalCalendarRepository.MonthDict.filter(item => item.name.toLowerCase().trim() == name.toLocaleLowerCase().trim())
            if (isValid.length > 0) {
              let sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[name], { raw: false });

              let headers = Object.keys(sheetData[0]);

              if(headers.includes("Dia") && isValid[0].id >= currentMonth)
              {
                let convertedDate = SeasonalCalendarRepository.FormatDateLocales(sheetData, name)
  
                convertedXLSX.push({
                  sheetName: name,
                  data: convertedDate
                });
              }

            }
          }

          this.convertedFile = [...convertedXLSX];
          console.log(this.convertedFile)
        }

        reader.readAsArrayBuffer(file);
      }
    },

    async saveImportedCalendars() {
      this.loading = true;
      SeasonalCalendarRepository.fullLoading = true;
      let monthsSelected = this.months.filter(item => item.checked == true && item.disable == false).map(i => i.name)
      this.monthsToCheck = [...monthsSelected]
      let formattedCalendars = SeasonalCalendarRepository.FormatCalendarExcel(this.convertedFile, monthsSelected)
      
      let objToSend = {
        ...formattedCalendars,
        RelatedIndicators: this.vinculatedIndicatorsToSave
      }

      await axios.post(`${urlMainAPI}/importcalendarsfromexcel`, objToSend)
        .then(() => defaultSuccess("Calendários Importados com Sucesso!"))
        .catch(err => console.error(err))
      this.$bvModal.hide('addingNewCalendar');
      this.$bvModal.hide('importCalendarModal');
      this.$emit("saved", this.sendSaved++);
      this.$emit("refreshTableCalendar", Math.random())
      await this.loadCalendars(true)
      SeasonalCalendarRepository.fullLoading = false;
    },

    async getCalendarsToExport() {
      let monthsSelected = this.months.filter(item => item.checked == true).map(i => i.name)
      let calendarsSelected = this.calendars.filter(item => item.checked == true).map(i => i.id)
      let objToSend = {
        CalendarIds: calendarsSelected,
        Months: monthsSelected
      }
      await axios.post(`${urlMainAPI}/exportcalendarsfromexcel`, objToSend).then(res => {
        let exportedData = res.data;

        if (exportedData.length == 0) {
          this.$bvToast.toast("Não foram encontrados calendários que atendam aos parâmetros enviados.", {
            title: "Nenhum valor encontrado.",
            variant: "warning",
            toaster: 'b-toaster-bottom-left',
            solid: true
          })
          return;
        }

        let monthsFound = Object.keys(exportedData);

        if (monthsFound.length > 0) {
          this.$bvToast.toast(`Dos meses selecionados, foram encontrados dados apenas para: ${monthsFound.join(', ')}.`, {
            title: "Meses encontrados.",
            variant: "info",
            toaster: 'b-toaster-bottom-left',
            solid: true
          })
        } else {
          this.$bvToast.toast(`Não foram encontrados dados para os meses selecionados.`, {
            title: "Nenhum mês a ser exportado.",
            variant: "warning",
            toaster: 'b-toaster-bottom-left',
            solid: true
          })
          return
        }


        const workbook = XLSX.utils.book_new();

        for (let sheetName in exportedData) {
          const sheetData = exportedData[sheetName];
          const worksheet = XLSX.utils.json_to_sheet(sheetData);
          XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        }

        // Exporte o arquivo Excel
        XLSX.writeFile(workbook, "CalendarioExport.xlsx");
      }).catch(err => console.error(err))

      this.$bvModal.hide("exportModalContainer");
    },

    async saveBudgetCalendar() {
      SeasonalCalendarRepository.fullLoading = true;
      let selectedCalendar = this.calendars.filter(item => item.id == this.idSelected)

      if (selectedCalendar.length > 0) {
        await axios.post(`${urlMainAPI}/setbudgetcalendar`, selectedCalendar[0])
          .then(() => {
            defaultSuccess("Histórico do Calendário Definido com Sucesso!");
          }).catch(err => {
            showError("Falha ao Definir Calendário como Budget.");
            console.error(err)
          })
      }
      SeasonalCalendarRepository.fullLoading = false;
      this.$bvModal.hide('showBudgetCalendarModal');
      await this.loadCalendars(true)
    },

    async restoreSelectedCalendars() {
      let selectedHistorics = [];

      this.calendarsHistory.forEach(item => {
        let found = item.historics.filter(h => h.isChecked == true)

        if (found.length > 0) {
          let ids = found.map(f => f.id)
          selectedHistorics.push(...ids)
        }
      })
      SeasonalCalendarRepository.fullLoading = true;
      if (selectedHistorics.length > 0) {
        await axios.post(`${urlMainAPI}/restorecalendarsfromhistory`, selectedHistorics)
          .then(() => {
            defaultSuccess("Calendários Restaurados com Sucesso!");
          })
          .catch(er => {
            showError("Falha ao Restaurar Calendários.");
            console.error(er)
          })

        this.$bvModal.hide('showHistoryCalendar')
      }
      SeasonalCalendarRepository.fullLoading = false;
      await this.loadCalendars(true)
    },

    async generateAccumulatedCalendar() {
      if (this.accumulatedCalendarName == "" || this.accumulatedCalendarName == null || this.accumulatedCalendarName == undefined) {
        this.$bvToast.toast("Digite um nome para o calendário acumulado.", {
          title: "Nome do Calendário Vazio.",
          variant: "warning",
          toaster: 'b-toaster-bottom-left',
          solid: true
        })
        return;
      }

      let calendarsChecked = this.calendars.filter(item => item.checked == true);

      if (calendarsChecked.length <= 1) {
        this.$bvToast.toast("Selecione ao menos 2 calendários.", {
          title: "Calendários não Selecionados.",
          variant: "warning",
          toaster: 'b-toaster-bottom-left',
          solid: true
        })
        return;
      }

      let objToSend = {
        CalendarIDS: calendarsChecked.map(item => item.id),
        CalendarName: this.accumulatedCalendarName
      }
      SeasonalCalendarRepository.fullLoading = true;
      this.loading = true;
      this.$bvModal.hide('accumulatedCalendarsModal');
      await axios.post(`${urlMainAPI}/generateaccumulatedcalendar`, objToSend)
        .then(() => defaultSuccess('Calendário Criado com Sucesso!'))
        .catch(err => {
          showError('Falha ao Criar Calendário.')
          console.error(err)
        })
        this.loading = false;
        SeasonalCalendarRepository.fullLoading = false;

      await this.loadCalendars(true)
    }
  },

  async mounted() {
    SeasonalCalendarRepository.fullLoading = true;
    this.loading = true;
    this.monthImported = null;
    await this.loadCalendars(true)

    this.months.forEach(item => {
      if (item.id < this.currentMonth) item.disable = true
      else item.disable = false
    })
    this.monthImported = "";
    SeasonalCalendarRepository.fullLoading = false;
    this.localRefresh = this.refreshTableCalendar;
    this.loading = false;
  },
}
</script>

<style scoped>
.calendar-table {
  height: inherit;
  margin: 4px 0 0 8px;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 0 2px #0008;
}

.height-grid-card,
.height-table {
  height: 100%;
  max-height: 100%;
  user-select: none;
}

.calendar-name {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  column-gap: 0.2rem;
}

.calendar-name svg {
  width: 15px;
}

.height-table>table>tbody>tr.calendar-selected {
  background-color: rgb(142, 210, 210);
}

.exportModalContainer,
.importModalContainer {
  display: flex;
  align-items: flex-start;
  column-gap: 1rem;
  width: 100%;
}

.exportModalContainer section,
.importModalContainer section {
  width: 100%;
}

.modalBtn,
.modalBtn section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 0.8rem;
  padding-top: 1rem;
  width: 100%;
}

.modalBtn button {
  padding: 0.3rem 1.2rem;
  border: none;
  border-radius: 0.2rem;
  font-weight: 500;
  font-size: 1rem;
  color: #ffffff;
  background-color: #B6B6B6;
}

.modalBtn button:last-child {
  background-color: #FF7122;
}



.importModalContainer {
  flex-direction: column;
}

.importModalContainer p:first-child {
  margin: 0;
}

.importModalContainer .inputFile {
  margin: 0.3rem 0;
}

.calendarIcon {
  width: 25px;
  height: 25px;
  color: #FF7122;
  margin-right: 3px;
}

.monthsFound {
  width: 100%;
  font-size: 0.8rem;
  font-weight: 500;
  color: #ffa722;
}

.relatedImportContainer {
  display: flex;
  align-items: flex-start;
  column-gap: 1rem;
  margin-top: 1rem;
}

.relatedImportCalendars {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 1rem;
  width: 100%;
  max-height: 25rem;
  overflow-y: auto;
}

.relatedImportCalendars section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  row-gap: 0.3rem;
}

.relatedImportCalendars section span {
  font-weight: 600;
  position: relative;
  width: 100%;
}

.relatedImportCalendars section span:after {
  content: "";
  width: 100%;
  height: 5px;
  background-color: #2c2c2c;
  display: block;
}

.relatedImportCalendars section input {
  width: 100%;
  border: 1px solid #FF7122;
  border-radius: 0.2rem;
  padding: 0.3rem;
}

.relatedImportIndicators {
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 0.8rem;
  max-height: 25rem;
  overflow-y: auto;
}

.relatedImportIndicators div {
  display: flex;
  align-items: center;
  column-gap: 0.3rem;
  cursor: move;
  background-color: #FCFCFC;
  border: 1px solid #AAD6D6;
  font-weight: 500;
  font-size: 1rem;
  padding: 0.3rem 0.2rem;
  border-radius: 0.2rem;
  user-select: none;
}

.relatedImportIndicators div svg {
  color: #33ABAB;
}
</style>

<style>
.custom-file-input~.custom-file-label[data-browse]::after {
  background-color: #FF7122 !important;
  color: #fff !important;
  font-weight: 500 !important;
  border: none !important;
  border-radius: 0 0.1rem 0.1rem 0 !important;
  content: "📂 Buscar" !important;
}
</style>